import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL_UTIL } from 'src/app/@core/utils';
import { Observable } from 'rxjs';
import { PerDiemDataApiResponse } from 'src/app/@shared/models';
import { HttpStatus } from 'src/app/@shared/models/add-employee.modal';
// import { HttpStatus } from './../../../@shared/models/add-employee.modal';
// import { PerDiemDataApiResponse } from './../../../@shared/models/per-diem.modal';

@Injectable({
  providedIn: 'root'
})
export class PerDiemService {

  constructor(private readonly httpClient: HttpClient) { }

  getCrewPerDiemDetails(jobScheduleId: string, jobScheduleStartDate: string, employeeID: number, pageNumber: number, pageSize: number): Observable<PerDiemDataApiResponse> {
    const params = new HttpParams().set('JobScheduleId', jobScheduleId).set('JobScheduleStartDate', jobScheduleStartDate).set('EmployeeID', employeeID).set('PageNumber', pageNumber).set('PageSize', pageSize);
    return this.httpClient.get<PerDiemDataApiResponse>(`${API_URL_UTIL.foreman.getCrewPerDiemDetails}`, { params });
  }

  updateCrewPerDiemDetails(jobScheduleId: string, employeeID: number, loggedInUser: string, perDiemAmount: number, perDiemRemarks: string): Observable<HttpStatus> {
    const params = new HttpParams().set('JobScheduleId', jobScheduleId).set('EmployeeID', employeeID).set('LoggedInUser', loggedInUser).set('PerDiemAmount', perDiemAmount).set('PerDiemRemarks', perDiemRemarks);
    return this.httpClient.post<HttpStatus>(`${API_URL_UTIL.foreman.saveJobScheduleCrewPerDiem}`, null, { params });
  }

  deletedPerDiemApi(JobScheduleCrewPerDiemID:string,loggedInUser: string): Observable<HttpStatus> {
    const params = new HttpParams().set('JobScheduleCrewPerDiemID', JobScheduleCrewPerDiemID).set('LoggedInUser', loggedInUser);
    return this.httpClient.delete<HttpStatus>(`${API_URL_UTIL.foreman.deletePerDiemApi}`, { params });
  }

}
